import { ReactNode } from 'react'
import { clsx } from 'clsx'
import { ResponsiveAlignedLayout } from './ResponsiveAlignedLayout'

interface ResponsiveAlignedScrollableLayoutProps {
  children: ReactNode
  maxContentWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl'
  className?: string
  alignment?: 'left' | 'center' | 'right'
  padding?: string
  scrollable?: boolean
}

export const ResponsiveAlignedScrollableLayout = ({
  children,
  maxContentWidth = '4xl',
  className,
  alignment = 'center',
  padding = 'p-6',
  scrollable = true,
}: ResponsiveAlignedScrollableLayoutProps) => {
  return (
    <div className={clsx(
      'w-full h-full',
      scrollable && 'overflow-auto',
      padding
    )}>
      <ResponsiveAlignedLayout
        maxContentWidth={maxContentWidth}
        alignment={alignment}
        className={className}
      >
        {children}
      </ResponsiveAlignedLayout>
    </div>
  )
}